import React, { useEffect } from "react";
import { Table, ConfigProvider } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import AdjustSalaryModal from "../employees/modal/AdjustSalaryModal";

const SalaryList = () => {
  const { salaryStore, payrollStore } = useStore();
  const { salaryList, loading, fetchEmployeeSalary } = salaryStore;
  const { isAdjustBtn } = payrollStore;

  useEffect(() => {
    fetchEmployeeSalary();
  }, []);

  const columns = [
    {
      title: "Date",
      dataIndex: "uploadDate",
      key: "uploadDate",
      width: 100,
    },
    {
      title: "Account No.",
      dataIndex: "employeeNumber", 
      key: "employeeNumber",
      width: 90,
    },
    {
      title: "Name",
      dataIndex: "employeeName",
      key: "employeeName",
      width: 180,
      ellipsis: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: 80,
      align: 'center',
    },
    {
      title: "Next Cut-off Date",
      dataIndex: "nextCutOff",
      key: "nextCutOff",
      width: 140,
      render: (value) => {
        const date = new Date(value);
        return isNaN(date.getTime())
          ? "-"
          : new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }).format(date);
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      width: 80,
      ellipsis: true,
      align: 'center',
    },
    {
      title: "Action", 
      dataIndex: "action",
      key: "action",
      width: 80,
      render: (_, record) =>
        isAdjustBtn ? <AdjustSalaryModal record={record} /> : null,
      align: 'center',
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <ConfigProvider
        theme={{
          token: {
            boxShadowSecondary:
              "0 4px 8px 0 rgba(0, 0, 0.5, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadiusLG: 8,
          },
          components: {
            Table: {
              headerBg: "#6D6D6D",
              headerColor: "white",
              headerSplitColor: "#6D6D6D",
            },
          },
        }}
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={salaryList}
          loading={loading}
          rowClassName={() => "custom-dark-row"}
          tableLayout="fixed"
          size="small"
          pagination={{
            size: "small",
            showSizeChanger: false,
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default observer(SalaryList);